import type { ISerialize } from '@/objects/ISerialize';

export class QueueStatus implements ISerialize {
    public Count: number;

    public Name: string;

    public WarningLimit: number;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { Count?: number; Name?: string | null; WarningLimit?: number }) {
        this.Count = values.Count ?? 0;

        this.Name = values.Name ?? '';

        this.WarningLimit = values.WarningLimit ?? 0;
    }

    public serialize(): string {
        return (
            '{' +
            `"Count": ${JSON.stringify(this.Count)}` +
            ',' +
            `"Name": ${JSON.stringify(this.Name)}` +
            ',' +
            `"WarningLimit": ${JSON.stringify(this.WarningLimit)}` +
            '}'
        );
    }

    /**
     * Creates an instance of QueueStatus from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { Count?: number; Name?: string | null; WarningLimit?: number }): QueueStatus {
        return new QueueStatus(values);
    }

    public static _FromServerJson(json: any): QueueStatus {
        return new QueueStatus({ Count: json.Count, Name: json.Name ?? '', WarningLimit: json.WarningLimit });
    }

    /**
     * Creates an instance of QueueStatus from another instance of QueueStatus.
     * @param other The QueueStatus you want to clone
     * @returns A cloned QueueStatus
     */
    public static FromOther(other: QueueStatus): QueueStatus {
        return QueueStatus._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return QueueStatus.FromOther(this);
    }

    static NAME_OF_CLASS = 'QueueStatus';
}
